import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  // Listing state
  teams: [],
  total: 0,
  page: 1,
  size: 25,
  search: '',
  filterType: 'ALL', // 'ALL' | 'PUBLIC' | 'PRIVATE'

  // View state
  showForm: false,
  editingTeam: null,

  // Form state (persists so user doesn't lose work on navigation)
  formData: {
    name: '',
    team_access_level: 'PRIVATE',
    userAccess: [],
  },
  selectedUsers: [],
};

const teamSlice = createSlice({
  name: 'team',
  initialState,
  reducers: {

    // ── Listing ────────────────────────────────────────────
    setTeams(state, action) {
      state.teams = action.payload;
    },

    setTotal(state, action) {
      state.total = action.payload;
    },

    setPage(state, action) {
      state.page = action.payload;
    },

    setSize(state, action) {
      state.size = action.payload;
    },

    setSearch(state, action) {
      state.search = action.payload;
    },

    setFilterType(state, action) {
      state.filterType = action.payload;
    },

    // ── View ───────────────────────────────────────────────
    setShowForm(state, action) {
      state.showForm = action.payload;
    },

    setEditingTeam(state, action) {
      state.editingTeam = action.payload;
    },

    // ── Form ───────────────────────────────────────────────
    setFormData(state, action) {
      state.formData = action.payload;
    },

    updateFormField(state, action) {
      const { field, value } = action.payload;
      state.formData[field] = value;
    },

    setSelectedUsers(state, action) {
      state.selectedUsers = action.payload;
    },

    // ── Bulk: populate form when editing ───────────────────
    loadEditingTeam(state, action) {
      const team = action.payload;
      state.editingTeam = team;
      state.showForm = true;
      state.formData = {
        name: team.name || '',
        team_access_level: team.team_access_level || 'PUBLIC',
        userAccess: team.user_access || [],
      };
      state.selectedUsers = (team.user_access || []).map(u => u.user_id);
    },

    // ── Reset form only ────────────────────────────────────
    resetForm(state) {
      state.formData = initialState.formData;
      state.selectedUsers = initialState.selectedUsers;
      state.editingTeam = null;
      state.showForm = false;
    },

    // ── Full reset ─────────────────────────────────────────
    resetTeamState() {
      return initialState;
    },
  },
});

export const {
  setTeams,
  setTotal,
  setPage,
  setSize,
  setSearch,
  setFilterType,
  setShowForm,
  setEditingTeam,
  setFormData,
  updateFormField,
  setSelectedUsers,
  loadEditingTeam,
  resetForm,
  resetTeamState,
} = teamSlice.actions;

export default teamSlice.reducer;